import {
  LivretEleveCompetence,
  LivretEleveDomaine,
  LivretEleveMatiere,
} from '@teetsh/app/src/containers/Livrets/types/livret';

export function updateCompetence(
  matiere: LivretEleveMatiere,
  competence: LivretEleveCompetence,
  domaine?: LivretEleveDomaine,
): LivretEleveMatiere {
  if (domaine) {
    const domaines = matiere.domaines.map(oldDomaine => {
      if (domaine && oldDomaine.id === domaine.id) {
        const competences = (oldDomaine?.competences || []).map(
          oldCompetence => {
            if (oldCompetence.id === competence.id) {
              return competence;
            }
            return oldCompetence;
          },
        );
        return {
          ...oldDomaine,
          competences,
        };
      }
      return oldDomaine;
    });
    return {
      ...matiere,
      domaines,
    };
  }
  const competences = (matiere?.competences || []).map(oldCompetence => {
    if (oldCompetence.id === competence.id) {
      return competence;
    }
    return oldCompetence;
  });
  return {
    ...matiere,
    competences,
  };
}
